module.exports = __webpack_public_path__ + "static/media/cloud-check.133b4079.svg";